import { QueryKey } from "@tanstack/react-query";
import { Container } from "@webmotors/ioc";
import { getMetadata } from "./metadata";

export function queryFn<T>(
  app: Container,
  providerName: string,
  argumentsList: any[] = []
): () => Promise<T> {
  const provider = app.resolve<Function>(providerName);

  const { propertyName } = getMetadata(provider, "__QUERY_FN__", {
    propertyName: null,
  })!;
  if (!propertyName) {
    throw new Error(`Query Fn function not found for query ${provider.name}`);
  }

  return () => Reflect.apply(provider[propertyName], provider, argumentsList);
}

export function queryKey(
  app: Container,
  providerName: string,
  argumentsList: any[] = []
) {
  const provider = app.resolve<Function>(providerName);

  const { propertyName } = getMetadata(provider, "__QUERY_KEY__", {
    propertyName: null,
  })!;
  if (!propertyName) {
    throw new Error(`Query Key function not found for query ${provider.name}`);
  }
  return Reflect.apply(
    provider[propertyName],
    provider,
    argumentsList
  ) as QueryKey;
}
